module.exports = __webpack_public_path__ + "static/index/img/baikal-506.cdb58e12.jpg";